const styles = {
  mainWrapper: {
    width: '100%',
    display: 'flex',
    marginBottom: '25px',
    flexWrap: 'nowrap',
    alignItems: 'flex-end',
    position: 'relative',

    '&.myMessageWrapper': {
      flexDirection: 'row-reverse',
    },
  },
  photo: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    overflow: 'hidden',

    '&>img': {
      width: '100%',
    },

    '&.myPhoto': {
      marginLeft: '12px',
    },
    '&.userPhoto': {
      marginRight: '12px',
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    alignSelf: 'flex-start',
    maxWidth: '60%',
    borderRadius: 8,
    margin: '0 5px',
    boxShadow: '0px 1px 1px #D0CBC4',
    position: 'relative',

    '&.ownMessageWrapper': {
      display: 'flex',
      backgroundColor: '#F8EDF0',
      padding: '8px 21px 3px 18px',
      alignSelf: 'flex-end',
    },
    '&.userMessageWrapper': {
      display: 'flex',
      backgroundColor: '#fcfbfb',
      padding: '8px 8px 3px 21px',
      alignSelf: 'flex-end',
    },
    '&.curveRight': {
      '&:before': {
        content: '""',
        bottom: '17px',
        right: '-12px',
        position: 'absolute',
        border: '0px solid',
        display: 'block',
        width: '12px',
        height: '10px',
        backgroundColor: 'transparent',
        borderBottomLeftRadius: '0%',
        borderBottomRightRadius: '83%',
        boxShadow: '-10px 8px 0px 7px #F8EDF0, -4px 12px 4px 1px #D0CBC4',
      },
    },
    '&.curveLeft': {
      '&:before': {
        content: '""',
        bottom: '17px',
        left: '-12px',
        position: 'absolute',
        border: '0px solid',
        display: 'block',
        width: '12px',
        height: '10px',
        backgroundColor: 'transparent',
        borderBottomLeftRadius: '0%',
        borderBottomRightRadius: '83%',
        boxShadow: '-10px 8px 0px 7px #fcfbfb, -4px 12px 4px 1px #D0CBC4',
        transform: 'rotateY(180deg)',
      },
    },
  },
  author: {
    fontSize: 12,
    marginBottom: 5,
  },
  time: {
    fontSize: 10,
    color: '#C9C8C8',
  },
  status: {
    display: 'flex',
    marginLeft: 8,
    flexDirection: 'row',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 18,
  },
  readMark: {
    marginRight: -5,
  },
  authorMessageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
  },
  footerStyles: {
    display: 'flex',
    alignItems: 'center',
  },
}
export default styles
